import {combineReducers} from "redux";
import user from '../domain/user/reducer'

const rootReducer = combineReducers({
    user: user
});

export default rootReducer
